import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { UTILS } from "utils";
import { API } from "api";
import { CONSTANTS as C } from "config";
import AppSwitch from "components/ui/AppSwitch.jsx";
import AppHeading2 from "components/ui/AppHeading2.jsx";
import AppInput from "components/ui/AppInput.jsx";
import AppSelect from "components/ui/AppSelect.jsx";
import AppSimpleText from "components/ui/AppSimpleText.jsx";
import AppCollapse from "components/ui/AppCollapse.jsx";
import AppRadioButton from "components/ui/AppRadioButton";
import StoreHoursSection from "./HoursSelection"
import {
  getHMinutSlotsTill8Hors,
  getThirdsDaysArrayWithDayLebel,
  getNumOfDaysWithZero,
} from "./constants";
// import PaymentTypes from "./StorePaymentMethodSection";
// import WorkingHours from "./PickupHoursSection";
// import RadioButton from "../../../components/RadioButton";
// import SectionHeading from "components/SectionHeading";
// import SimpleRadioButton from "components/SimpleRadioButton";
// import PreOrderingWidgetForPickup from "./PreOrderingWidgetForPickup";
// import OrderManagement from "./OrderManagement";
function Pickup({ store, addStore, type, setStore, handleStoreInfo, defaultOpen = false }) {
  const [serviceTypes, setServiceTypes] = useState([]);
  const { t } = useTranslation();

  const infoMessages = [
    {
      message:
        "To Receive Payments in Your Bank Account Please email us at",
      separator: "or",
      links:[
        {
          href: `mailto:info@resthero.io`,
          text: "info@resthero.io",
          target: "_blank",
        },
        {
          href: `https://wa.me/971527325000?text=How%20can%20we%20help?`,
          text: "Contact our Support Team",
          target: "_blank",
        },
      ],
    },
    {
      message: "To Enable Payment Methods (Cash, Card Payments, Card on Delivery, etc.) ",
      separator: "and we’ll help you activate the payment options you need",
      links:[
        {
          href: `https://wa.me/971527325000?text=How%20can%20we%20help?`,
          text: "Contact our Support Team",
          target: "_blank",
        },
      ],
    },
  ];
  
  const getServiceTypes = async () => {
    const userDetail = UTILS.getCurrentUser();
    const result = await API.GET_SERVICE_TYPES({
      token: userDetail.token,
    });
    if (result && result.success === 1) {
      setServiceTypes(result.data);
      console.log('is on:',serviceTypes[1]?._id)
      console.log(isON(serviceTypes[1]?._id))
    } else {
    }
  };
  
  useEffect(() => {
    getServiceTypes();
  }, []);
  const toggleDelivery = (isDeliveryEnabled, key) => {
    if (isDeliveryEnabled) {
      setStore((store) => ({
        ...store,
        values: {
          ...store.values,
          [C.ISPICKUPENABLED]: !isDeliveryEnabled,
          [C.KEY_SERVICE_TYPES]: store.values[C.KEY_SERVICE_TYPES].filter(
            (item) => item !== key
          ),
        },
      }));
    } else {
      setStore((store) => ({
        ...store,
        values: {
          ...store.values,
          [C.ISPICKUPENABLED]: !isDeliveryEnabled,
          serviceType: [...store.values.serviceType, key],
        },
      }));
    }
  };

  const isON = (item) => {
    const arr = store.values[C.KEY_SERVICE_TYPES];
    const found = arr?.find((obj) => obj === item);
    return found ? true : false;
  };
  
  const hndlepreOrderingState = (key, val) => {
    setStore((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val,
      },
      errors: {
        ...prevState.errors,
      },
    }));
  };

  const handlePreOrderingTiming = (key, val) => {
    setStore((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        preOrderSettingsForPickup: {
          ...prevState.values.preOrderSettingsForPickup,
          [key]: val,
        },
      },
      errors: {
        ...prevState.errors,
      },
    }));
  };
  // const ServiceType = () => {
  //   return (
  //     <div className="mb-5">
  //       <RadioButton
  //         label={t("Pickup")}
  //         value={isON(serviceTypes[1]?._id)}
  //         keyVal={C.KEY_SERVICE_TYPES + "_" + serviceTypes[1]?._id}
  //         handleValues={() => {
  //           toggleDelivery(
  //             store.values[C.ISPICKUPENABLED],
  //             serviceTypes[1]?._id
  //           );
  //         }}
  //       />
  //     </div>
  //   );
  // };
  const getValue = (key) => {
    if (store && store.values[key]) return store.values[key];
    else return "";
  };

  const handlePaymentTypes = (key, val) => {
    const v = key;
    let paymentArr = store?.values[C.KEY_PICKUP_PAYMENT_TYPES];
    if (val) {
      paymentArr?.push(v);
    } else {
      const index = paymentArr.indexOf(v);
      if (index > -1) paymentArr.splice(index, 1);
    }
    setStore((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [C.KEY_PICKUP_PAYMENT_TYPES]: paymentArr,
      },
      errors: {
        ...prevState.errors,
      },
    }));
  };

  const handleTwentyFourHours = (key, val) => {
    setStore((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val,
      },
      errors: {
        ...prevState.errors,
      },
    }));

    if (val) {
      setStore((prevState) => ({
        ...prevState,
        values: {
          ...prevState.values,
          [key]: val,
          workingHoursForPickup: {
            saturdayStartTime: C.START_TIME_24_HOURS,
            saturdayEndTime: C.END_TIME_24_HOURS,
            saturdayStartTimeSlot2: null,
            saturdayEndTimeSlot2: null,

            sundayStartTime: C.START_TIME_24_HOURS,
            sundayEndTime: C.END_TIME_24_HOURS,
            sundayStartTimeSlot2: null,
            sundayEndTimeSlot2: null,

            mondayStartTime: C.START_TIME_24_HOURS,
            mondayEndTime: C.END_TIME_24_HOURS,
            mondayStartTimeSlot2: null,
            mondayEndTimeSlot2: null,

            tuesdayStartTime: C.START_TIME_24_HOURS,
            tuesdayEndTime: C.END_TIME_24_HOURS,
            tuesdayStartTimeSlot2: null,
            tuesdayEndTimeSlot2: null,

            wednesdayStartTime: C.START_TIME_24_HOURS,
            wednesdayEndTime: C.END_TIME_24_HOURS,
            wednesdayStartTimeSlot2: null,
            wednesdayEndTimeSlot2: null,

            thursdayStartTime: C.START_TIME_24_HOURS,
            thursdayEndTime: C.END_TIME_24_HOURS,
            thursdayStartTimeSlot2: null,
            thursdayEndTimeSlot2: null,

            fridayStartTime: C.START_TIME_24_HOURS,
            fridayEndTime: C.END_TIME_24_HOURS,
            fridayStartTimeSlot2: null,
            fridayEndTimeSlot2: null,

            sunday: true,
            saturday: true,
            friday: true,
            thursday: true,
            wednesday: true,
            tuesday: true,
            monday: true,
          },
        },
        errors: {
          ...prevState.errors,
        },
      }));
    }
  };

  const handlePickupVehicleInfo = (key, val) => {
    setStore((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val,
      },
      errors: {
        ...prevState.errors,
      },
    }));
  };
  const handleQuickOrders = (key, val) => {
    setStore((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val,
      },
      errors: {
        ...prevState.errors,
      },
    }));
  };

  return (
  
    <div className="w-full mb-3">
      <AppCollapse
          defaultOpen={defaultOpen}
          title={t("Pickup Options")}
          subtitle={t("Configure options for in-store pickups.")}
        ><div className="space-y-6">
            <div className="flex items-center">
              <AppSwitch label={t("Pickup")} labelLeft={false} checked={isON(serviceTypes[1]?._id)}  onChange={(val)=>toggleDelivery( store.values[C.ISPICKUPENABLED], serviceTypes[1]?._id)}/>
            </div>
            {isON(serviceTypes[1]?._id) &&
              <>
                <div className="space-y-3">
                  <AppHeading2>Supported Payment Methods?</AppHeading2>
                  <ul className="px-5 text-blue-600 text-16px space-y-2 list-disc">
                    {infoMessages.map((item,index)=>(
                    <li key={index} className="text-sm leading-relaxed">
                    <span>{t(item.message)} </span>
                    {item.links.map((link, i) => (
                      <React.Fragment key={i}>
                        <a
                          href={link.href}
                          target={link.target}
                          rel="noopener noreferrer"
                          className="text-red-600 underline mx-1"
                        >
                          {t(link.text)}
                        </a>
                        {i < item.links.length - 1 && <span>{t(item.separator)}</span>}
                      </React.Fragment>
                    ))}
                    {item.links.length === 1 && <span>{t(item.separator)}</span>}.
                  </li>
                  
                    ))}
                  </ul>
                </div>

              {/* Preparation Time */}
              <AppInput
                label="Average Preparation Time"
                placeholder="Example 30 Mins"
                value={store?.values?.averagePrepTimeForPickup}
                onInput={(e)=>handleStoreInfo("averagePrepTimeForPickup", e.target.value)}
              />

              {/* ASAP Orders */}
              <div className="flex items-center">
              <AppSwitch 
                label="Accept ASAP orders" 
                labelLeft={false}
                checked={store?.values?.isAcceptQuickOrderForPickup}
                onChange={(e)=>handleStoreInfo("isAcceptQuickOrderForPickup", e)} 
              />
              </div>

              {/* Pre-Orders */}
              <div className="space-y-3">
                <AppHeading2>{t("Vehicle Information")}</AppHeading2>

                <div className="flex items-center">
                  <AppSwitch 
                    label={t("Vehicle Info")} 
                    labelLeft={false} 
                    checked={store.values?.vehicleInfoForPickup?.isActive}
                    onChange={(val)=>handlePickupVehicleInfo("vehicleInfoForPickup", {
                      ...store.values?.vehicleInfoForPickup,
                      isActive: val,
                    })}
                    />
                </div>
                {store.values?.vehicleInfoForPickup?.isActive && (
                  <div className="flex items-center gap-2 flex-wrap my-3">
                    <AppRadioButton
                      name="pickup-vehicle-info-required"
                      value={true}
                      title={t("Required")}
                      checked={
                        store.values?.vehicleInfoForPickup?.isRequired === true
                      }
                      onChange={(val) =>
                        handlePickupVehicleInfo("vehicleInfoForPickup", {
                          ...store.values?.vehicleInfoForPickup,
                          isRequired: val,
                        })
                      }
                    />
                    <AppRadioButton
                      name="pickup-vehicle-info-required"
                      value={false}
                      title={t("Optional")}
                      checked={
                        store.values?.vehicleInfoForPickup?.isRequired !== true
                      }
                      onChange={(val) =>
                        handlePickupVehicleInfo("vehicleInfoForPickup", {
                          ...store.values?.vehicleInfoForPickup,
                          isRequired: val,
                        })
                      }
                    />
                  </div>
                )}
                
              </div>

              <div className="space-y-3">
                <AppHeading2>Do you want to accept pre-orders?</AppHeading2>

                <div className="flex items-center">
                  {/* <AppSwitch label="Accept Pre-orders" labelLeft={false} checked={store?.values?.isPreOrderEnabledForPickup} onChange={(val)=>handleStoreInfo("isPreOrderEnabledForPickup", val)} /> */}
                  <AppSwitch
                    label="Accept Pre-orders"
                    labelLeft={false}
                    checked={store?.values?.isPreOrderEnabledForPickup}
                    onChange={(val) =>
                      handleStoreInfo("isPreOrderEnabledForPickup", val)
                    }
                  />
                </div>

                {store?.values?.isPreOrderEnabledForPickup && (
                  <div className="flex items-center">
                    <AppSwitch
                      label="Accept Same Day Pre-Orders"
                      labelLeft={false}
                      checked={store?.values?.preOrderSettingsForPickup?.acceptTodayPreOrders} onChange={(val)=>handlePreOrderingTiming("acceptTodayPreOrders", val)} />
                  </div>
                )}
              </div>

              {store?.values?.isPreOrderEnabledForPickup && (
              <>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <AppSelect 
                  label="Minimum Lead Time Unit" 
                  value={store?.values?.preOrderSettingsForPickup?.minTimeInAdvanceUnit}
                  placeholder={t("Select Unit")}
                  onChange={(e)=>{handlePreOrderingTiming("minTimeInAdvanceUnit",e);handlePreOrderingTiming("minTimeInAdvance",'')}}
                  options={[
                    {
                      _id: "1",
                      label: t("Hours"),
                      value: "hours",
                    },
                    {
                      _id: "2",
                      label: t("Minutes"),
                      value: "minutes",
                    },
                  ]}

                />
                <AppInput label="Enter Minimum Lead Time" placeholder={t("Enter Minimum Lead Time")} value={store?.values?.preOrderSettingsForPickup?.minTimeInAdvance} onInput={(e)=>handlePreOrderingTiming("minTimeInAdvance", Number(e.target.value))} />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <AppSelect 
                  label="Max Days In Advance" 
                  placeholder={t("select minutes")}
                  value={store?.values?.preOrderSettingsForPickup?.maxDaysInAdvance}
                  options={getThirdsDaysArrayWithDayLebel()}
                  onChange={(e)=>handlePreOrderingTiming("maxDaysInAdvance",e)}
                />
                <AppSelect 
                  label="Slot Length"
                  placeholder={t("Select Slot Length")}
                  value={store?.values?.preOrderSettingsForPickup?.timeInterval}
                  options={getHMinutSlotsTill8Hors()}
                  onChange={(e)=>handlePreOrderingTiming("timeInterval",e)}
                    />
              </div>

              <AppSelect 
                label="Minimum Days In Advance" 
                value={store?.values?.preOrderSettingsForPickup?.minDaysInAdvance}
                placeholder={t("select minutes")}
                options={getNumOfDaysWithZero()}
                onChange={(e)=>handlePreOrderingTiming("minDaysInAdvance",e)}
              />
              </>
              )}

              <div className="space-y-3">
                <AppHeading2>
                  {t("Set the hours your store is open for delivery")}
                </AppHeading2>

                <div className="flex items-center">
                  <AppSwitch
                    label="Open 24 Hours to Accept Orders"
                    labelLeft={false}
                    checked={store?.values?.isStoreOpen24HoursForPickup}
                    onChange={(e)=>handleTwentyFourHours('isStoreOpen24HoursForPickup',e)}
                  />
                </div>
                {
                  !store?.values?.isStoreOpen24HoursForPickup && 
                  <div className="w-full">
                    <StoreHoursSection store={store} setStore={setStore} hoursField="workingHoursForPickup" />
                  </div>
                }  
              </div>
              </>
            }
          </div>
        </AppCollapse>
      
    </div>
  );
}

export default Pickup;
